import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../services/firebase';
import toast from 'react-hot-toast';

const TestNotification = () => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const sendTestNotification = async () => {
    if (!username.trim()) {
      toast.error('Por favor ingresa un username');
      return;
    }

    setLoading(true);
    try {
      const functions = getFunctions(app);
      const testNotification = httpsCallable(functions, 'testManualNotification');
      
      const response = await testNotification({ username });
      
      if (response.data.success) {
        toast.success('Notificación enviada exitosamente');
        setResult(response.data);
      } else {
        toast.error('Error al enviar notificación');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al enviar notificación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-4">Probar Notificaciones</h1>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Username (como aparece en Android)
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            placeholder="ej: usuario123"
          />
        </div>
        
        <button
          onClick={sendTestNotification}
          disabled={loading}
          className="w-full px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition-colors disabled:opacity-50"
        >
          {loading ? 'Enviando...' : 'Enviar Notificación de Prueba'}
        </button>
        
        {result && (
          <div className="mt-4 p-4 bg-gray-100 rounded-lg">
            <p className="text-sm font-medium">Resultado:</p>
            <pre className="text-xs mt-2 overflow-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Nota:</strong> Para que las notificaciones funcionen:
          </p>
          <ul className="text-sm text-blue-700 mt-2 list-disc list-inside">
            <li>La app de Android debe estar instalada</li>
            <li>Debes haber iniciado sesión con este username</li>
            <li>Los permisos de notificación deben estar activados</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestNotification;